import { api } from "./client";
import type { DocumentOut, DocumentSummary } from "@/types/api";

export async function listConversationDocuments(convId: number): Promise<DocumentSummary[]> {
  const { data } = await api.get<DocumentSummary[]>(`/conversations/${convId}/documents`);
  return data;
}

export async function getDocument(docId: number): Promise<DocumentOut> {
  const { data } = await api.get<DocumentOut>(`/documents/${docId}`);
  return data;
}

export function downloadDocumentUrl(docId: number): string {
  return `/api/documents/${docId}/download`;
}
